import theme from '../../theme';

export const S: { [key: string]: React.CSSProperties } = {
    title: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '19px',
        color: theme.color.white90,
        marginLeft: '0px',
        marginBottom: '10px'
    }
};
